<script setup lang="ts">
/**
 * Persistent "Viewing as …" banner shown whenever a "View as" preview is active
 * (admin/advisor previewing the portal as a lower role / a specific household).
 * Gold, top-of-shell, with a one-click Exit. Rendered once by layouts/default.vue.
 */
const { active, role, householdName, repName, exit } = useViewAs()
const exiting = ref(false)
// Show the scoped household (Client) or representative (Representative) name.
const scopeLabel = computed(() => householdName.value || repName.value || null)

async function onExit() {
  if (exiting.value) return
  exiting.value = true
  try { await exit() } finally { exiting.value = false }
}
</script>

<template>
  <div
    v-if="active"
    class="flex items-center justify-center gap-2 bg-[#C79900] px-4 py-2 text-center text-sm font-nunito tracking-wide text-white"
    role="status"
  >
    <UIcon name="i-lucide-eye" class="size-4 shrink-0" />
    <span class="font-semibold">
      Viewing as {{ role }}<template v-if="scopeLabel"> — {{ scopeLabel }}</template>
    </span>
    <button
      type="button"
      class="ml-2 cursor-pointer font-semibold underline underline-offset-2 hover:opacity-90 disabled:opacity-60"
      :disabled="exiting"
      @click="onExit"
    >
      {{ exiting ? 'Exiting…' : 'Exit' }}
    </button>
  </div>
</template>
